module.exports = __webpack_public_path__ + "img/ws_Logo.191522da.png";